<template>
  <div>
    <h4>Transactions View</h4>
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center mb-4">
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{
                  (currentTransactionPage - 1) * paginationPageSize + 1
                }}
                -
                {{
                  currentTransactionPage * paginationPageSize > totalTransactions
                    ? totalTransactions
                    : currentTransactionPage * paginationPageSize
                }}
                of {{ totalTransactions }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="changePageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changePageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changePageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changePageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <div class="flex items-center sm:mr-4 mr-0 sm:order-normal order-3 sm:mt-0 mt-4">
          <vs-input
            class="sm:w-auto w-full"
            v-model="searchQuery"
            @keyup.enter="performSearch"
            placeholder="Search..."
          />
          <vs-button
            class="ml-2"
            icon="search"
            @click="performSearch"
          ></vs-button>
        </div>
      </div>

      <vs-table :data="transactions">
        <template slot="thead">
          <vs-th sort-key="ref">ID</vs-th>
          <vs-th sort-key="date">Date</vs-th>
          <vs-th sort-key="products"># Products</vs-th>
          <vs-th sort-key="client">Client</vs-th>
          <vs-th sort-key="amount">Amount</vs-th>
          <vs-th sort-key="type">Type</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :id="indextr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            :state="
              data[indextr].type == 'Paiement client'
                ? 'warning'
                : data[indextr].type == 'Vente de produit'
                ? 'success'
                : data[indextr].type == 'Retour produit'
                ? 'danger'
                : null
            "
          >
            <vs-td :data="data[indextr].ref">
              {{ data[indextr].ref }}
            </vs-td>

            <vs-td :data="data[indextr].createdAt">
              {{ data[indextr].createdAt | datemongoose(true) }} -
              {{ data[indextr].createdAt | time() }}
            </vs-td>

            <vs-td :data="data[indextr].products.length">
              {{ data[indextr].products.length }}
            </vs-td>

            <vs-td :data="data[indextr].products && data[indextr].products[0] && data[indextr].products[0].client ? data[indextr].products[0].client.display : 'N/A'">
              <p
                v-for="(client, index) in data[indextr].products
                  .map((product) => product.client && product.client.display)
                  .filter((val, i, arr) => val && arr.indexOf(val) === i)"
                :key="index"
              >
                {{ client }}
              </p>
            </vs-td>
            <vs-td :data="data[indextr].amount">
              {{ data[indextr].amount }}
            </vs-td>

            <vs-td :data="data[indextr].type">
              {{ data[indextr].type }}
            </vs-td>

            <template class="expand-user" slot="expand">
              <div class="con-expand-users w-full py-6 px-10">
                <div class="con-btns-user flex items-center justify-between">
                  <div class="con-userx flex items-center justify-start">
                    <div>
                      <div>
                        <h6>Transaction #{{ data[indextr].ref }}</h6>
                      </div>
                    </div>
                  </div>
                  <div class="flex">
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="mr-2"
                      @click="viewDetails(tr._id)"
                    >
                    </vs-button>

                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-edit"
                      color="success"
                      class="mr-2"
                    ></vs-button>
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-trash"
                      color="danger"
                    ></vs-button>
                  </div>
                </div>
                <vs-list>
                  <vs-list-item
                    v-for="(product, index) in tr.products"
                    :key="index"
                    icon-pack="feather"
                    icon="icon-tag"
                    :title="product.name"
                    class="w-1/2"
                  >
                    <p>Client: {{ product.client.display }}</p>
                    <p>Prix de vente: {{ product.sale_price }}</p>
                    <p>Rémunération déposant: {{ product.client_price }}</p>
                    <p>
                      Date:
                      {{ data[indextr].createdAt | datemongoose(true) }}
                    </p>
                  </vs-list-item>
                </vs-list>
              </div>
            </template>
          </vs-tr>
        </template>
      </vs-table>

      <vs-pagination 
        :total="totalTransactionPages" 
        :max="7" 
        :value="currentTransactionPage"
        @input="handlePageChange"
        class="mt-4"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchQuery: "",
      pageSize: 25,
    };
  },
  computed: {
    transactions() {
      return this.$store.getters.getTransactions;
    },
    paginationPageSize() {
      return this.pageSize;
    },
    totalTransactionPages() {
      const pages = this.$store.getters.getTotalTransactionPages;
      const numPages = typeof pages === 'number' ? pages : parseInt(pages) || 1;
      return numPages > 0 ? numPages : 1;
    },
    totalTransactions() {
      return this.$store.getters.getTotalTransactions;
    },
    currentTransactionPage() {
      return Number(this.$store.getters.getCurrentTransactionPage) || 1;
    },
  },
  methods: {
    viewDetails() {
      this.$router.push(`/contract`).catch(() => {});
    },
    async fetchTransactions(page = 1) {
      try {
        await this.$store.dispatch("TRANSACTIONS_REQUEST", {
          page,
          limit: this.pageSize,
          search: this.searchQuery,
        });
      } catch (error) {
        this.$vs.notify({
          title: "Erreur",
          text: "Une erreur s'est produite lors du chargement des transactions",
          color: "danger",
          position: "top-center",
        });
      }
    },
    performSearch() {
      this.fetchTransactions(1); // Reset to first page and search
    },
    changePageSize(newSize) {
      this.pageSize = newSize;
      this.fetchTransactions(1); // Reset to first page and fetch
    },
    handlePageChange(page) {
      const pageNum = Number(page);
      if (pageNum !== this.currentTransactionPage) {
        this.fetchTransactions(pageNum);
      }
    },
  },
  async beforeMount() {
    await this.fetchTransactions(1);
  },
};
</script>
